export default __webpack_public_path__ + "static/media/power_bidder.fb4ca093.png";